import React, { useState, useMemo } from "react"
import { Input } from "antd"
import AccessBlock from "./AccessBlock"
import { SiteAccess } from "../../../store/branches/sites/stateTypes"
import classes from "../AddUser.module.scss"

interface AccessListProps {
    accessList: SiteAccess[]
    onSaveHasAccess: (id: number, has_access: boolean) => void
    onSavePermission: (id: number, permission: SiteAccess["permission"]) => void
}

const AccessList: React.FC<AccessListProps> = ({ accessList, onSaveHasAccess, onSavePermission }) => {
    const [search, setSearch] = useState("")

    const filteredList = useMemo(() => {
        return accessList.filter(item =>
            item.site.toLowerCase().includes(search.toLowerCase())
        )
    }, [accessList, search])

    return (
        <div className={classes.siteAccessWrap}>
            <div className={classes.titleBlock}>
                <span className={classes.title}>Site Access</span>
            </div>
                         <Input
                    placeholder="Search sites..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className={classes.searchInput}
                />
            <div className={"d-flex"}>
                <div className={classes.subTitle}>
                    <span>Site</span>
                </div>

                <div className={classes.subTitle}>
                    <span>Has Access</span>
                </div>

                <div className={classes.subTitle}>
                    <span className={classes.subTitle}>Permissions</span>
                </div>
            </div>
            <div>

                <div className={classes.accessListContainer}>
                    <div className={classes.accessList}>
                        {filteredList.map((access) => (
                            <AccessBlock
                                key={access.id}
                                locationAccess={access}
                                onSaveHasAccess={onSaveHasAccess}
                                onSavePermission={onSavePermission}
                            />
                        ))}
                    </div>
                </div>
            </div>
             </div>

            )
            }

            export default AccessList
